import { reactive } from 'vue'
import type { Address } from '@/types/retail'

export type MapInteraction = {
  hover?: number
  active?: Address
}

export type GeocodeRes = {
  status: 'OK' | 'ZERO_RESULTS' | 'OVER_QUERY_LIMIT' | 'REQUEST_DENIED' | 'INVALID_REQUEST' | 'UNKNOWN_ERROR' | 'ERROR'
  results: GeocodeResult[]
}

export type GeocodeResult = {
  formatted_address: string
  geometry: {
    location: Coordinates
  }
}

export type Coordinates = { lat: number, lng: number }

export const mapInteraction = reactive<MapInteraction>({})

export const MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY

export const usCenterCoordinates = { lat: 39.8097343, lng: -98.5556199 }

export const focusRetailSearch = () => document.getElementById('input-retail-search')?.focus()


export const geocode = async (address: string) => {
  const res = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=${import.meta.env.VITE_GOOGLE_GEOCODE_API_KEY}`)
  const data = await res.json() as GeocodeRes
  
  if (data.status === 'OK') {
    return data.results[0].geometry.location
  } else if (data.status === 'ZERO_RESULTS') {
    throw new Error(`Zero results have been found while geocoding the following address: ${address}`)
  } else {
    throw new Error(`Error while geocoding address ${address}`)
  }
}
